"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const WebRenderer_1 = require("./preview/WebRenderer");
const web3DAppUtil_1 = require("../utils/web3DAppUtil");
const react_dom_1 = require("react-dom");
const BaseCard_1 = require("./ui/BaseCard");
require("../styles/App.scss");
var Apps;
(function (Apps) {
    Apps[Apps["NONE"] = 0] = "NONE";
    Apps[Apps["BABYLONJS"] = 1] = "BABYLONJS";
})(Apps || (Apps = {}));
var Actions;
(function (Actions) {
    Actions["THREED_APP_START"] = "3D_APP_START";
    Actions["AR_APP_START"] = "AR_APP_START";
})(Actions || (Actions = {}));
const App = () => {
    const [app, setApp] = (0, react_1.useState)(Apps.NONE);
    const [showMobileHint, setShowMobileHint] = (0, react_1.useState)(true);
    const [forceStartAr, setForceStartAr] = (0, react_1.useState)(false);
    const babylonApps = (0, web3DAppUtil_1.find3DApps)();
    const modelViewerRef = (0, react_1.createRef)();
    /**
     * conditionally renders a template to render a application
     */
    const renderCanvas = ({ fileUrl, articleAppUrl, fileUrlAndroid, descriptions, cameraAlpha, cameraBeta, withTransparency, cameraRadius, cameraVectorZ, cameraVectorY, cameraVectorX, scaleWebXR, }) => {
        if (app !== Apps.BABYLONJS) {
        }
        switch (app) {
            case Apps.BABYLONJS:
                return ((0, jsx_runtime_1.jsx)(WebRenderer_1.WebRenderer, { ref: modelViewerRef, articleAppUrl: articleAppUrl, fileUrl: fileUrl, fileUrlAndroid: fileUrlAndroid, showCameraSelection: false, descriptions: descriptions, showMobileHint: showMobileHint, onMobileHintClose: () => setShowMobileHint(false), cameraAlpha: Number(cameraAlpha.value), cameraBeta: Number(cameraBeta.value), cameraRadius: Number(cameraRadius.value), cameraVectorX: Number(cameraVectorX.value), cameraVectorY: Number(cameraVectorY.value), cameraVectorZ: Number(cameraVectorZ.value), withTransparency: withTransparency !== null && withTransparency !== void 0 ? withTransparency : true, scrollIntoView: true, forceStartAR: forceStartAr, scaleWebXR: scaleWebXR }));
            default:
                return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
        }
    };
    (0, react_1.useEffect)(() => {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get("view") === "ar") {
            setForceStartAr(true);
            setApp(Apps.BABYLONJS);
        }
    }, []);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: babylonApps.map((babylonApp) => (0, react_dom_1.createPortal)((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: "row", children: (0, jsx_runtime_1.jsxs)("div", { className: "small-12 medium-12 large-12 columns", children: [(0, jsx_runtime_1.jsx)("h3", { children: babylonApp.title.value }), (0, jsx_runtime_1.jsx)("p", { children: babylonApp.text.value }), (0, jsx_runtime_1.jsx)("div", { className: "cards", children: babylonApp.textboxes.map((textbox, index) => {
                                    const getCardFooter = (urlOrAction, buttonText) => {
                                        switch (urlOrAction) {
                                            case Actions.THREED_APP_START:
                                                return ((0, jsx_runtime_1.jsx)("button", { style: { marginRight: "1rem", marginTop: "auto" }, onClick: () => {
                                                        setApp(Apps.BABYLONJS);
                                                    }, children: buttonText }));
                                            case Actions.AR_APP_START:
                                                return ((0, jsx_runtime_1.jsx)("button", { style: { marginRight: "1rem", marginTop: "auto" }, onClick: () => {
                                                        setShowMobileHint(true);
                                                        setForceStartAr(true);
                                                        setApp(Apps.BABYLONJS);
                                                    }, children: buttonText }));
                                            default:
                                                return ((0, jsx_runtime_1.jsx)("a", { href: urlOrAction, className: "button", target: "_blank", style: {
                                                        display: "inline-block",
                                                        marginRight: "1rem",
                                                        marginTop: "auto",
                                                    }, children: buttonText }));
                                        }
                                    };
                                    return ((0, jsx_runtime_1.jsx)(BaseCard_1.BaseCard, { text: textbox.text, footer: getCardFooter(textbox.urloraction, textbox.buttontext) }, index));
                                }) })] }) }), renderCanvas(babylonApp)] }), babylonApp.element)) }));
};
exports.default = App;
